import { useState, useEffect } from 'react';
import PromotionsSubTabs from './PromotionsSubTabs';
import { axiosInstance } from '../../lib/api-client';

export default function PromotionsManagement() {
  const [canCreateOrders, setCanCreateOrders] = useState(false);
  const [showPromotionsTab, setShowPromotionsTab] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    try {
      const response = await axiosInstance.get('/promotional-orders/settings');
      if (response.data.success) {
        setCanCreateOrders(response.data.data.canCreatePromotionalOrders || false);
        setShowPromotionsTab(response.data.data.showPromotionsTab !== false);
      }
    } catch (error) {
      console.error('Failed to check permissions:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin w-8 h-8 border-4 border-rose-500 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!showPromotionsTab) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
        <p className="text-yellow-800 font-medium">
          The promotions feature is currently not available for your account.
        </p>
        <p className="text-yellow-700 text-sm mt-2">
          Please contact your administrator to enable this feature.
        </p>
      </div>
    );
  }

  return <PromotionsSubTabs canCreateOrders={canCreateOrders} />;
}

export { PromotionsManagement };